import { Label } from '@windmill/react-ui';
import ReactSelect, { Props, GroupBase, SelectInstance } from 'react-select';
import classnames from 'classnames';
import { useRef } from 'react';

interface OptionType {
  isFixed?: boolean;
  [key: string]: any;
}

export interface SelectProps<
  Option extends OptionType = OptionType,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> extends Props<Option, IsMulti, Group> {
  label: string;
  danger?: boolean;
  wrapperClassName?: string;
  required?: boolean;
}

export default function Select<
  Option extends OptionType = OptionType,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: SelectProps<Option, IsMulti, Group>) {
  const {
    label,
    isMulti = undefined,
    danger,
    wrapperClassName,
    value,
    required,
    ...rest
  } = props;
  const selectRef = useRef<SelectInstance<Option, IsMulti, Group>>(null);

  return (
    <Label className={classnames(wrapperClassName)}>
      <span className={classnames({ 'text-danger': danger })}>{label}</span>
      <ReactSelect<Option, IsMulti, Group>
        {...rest}
        isMulti={isMulti}
        value={value}
        styles={{
          control: (provided: any) => {
            const minHeight = '46px';
            return { ...provided, minHeight };
          },
          placeholder: () => ({}),
          singleValue: () => ({}),
          multiValue: (base, state) =>
            state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base,
          multiValueLabel: (base, state) =>
            state.data.isFixed
              ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 }
              : base,
          multiValueRemove: (base, state) =>
            state.data.isFixed ? { ...base, display: 'none' } : base,
        }}
        ref={selectRef}
      />
      {required && (
        <input
          value={value ? value.toString() : ''}
          required
          tabIndex={-1}
          autoComplete="off"
          style={{
            opacity: 0,
            width: 1,
            height: 1,
            position: 'absolute',
          }}
          onChange={() => {}}
          onFocus={() => selectRef.current?.focus()}
        />
      )}
    </Label>
  );
}
